module.exports = __webpack_public_path__ + "newprotal/img/adv-03.25af93c1.jpg";